const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`,
    cursor: `pointer`,
    ':hover': {
      border: `1px solid #666`,
      background: `#fbfbfb`
    }
  },
  activeRow: {
    border: `1px solid #666`,
    background: `#fbfbfb`
  },
  header: {
    borderBottom: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserTable/style/ColorBlind/list.js